import { render, staticRenderFns } from "./AssetsCorpPage.vue?vue&type=template&id=8cc90de6&scoped=true"
import script from "./AssetsCorpPage.vue?vue&type=script&lang=js"
export * from "./AssetsCorpPage.vue?vue&type=script&lang=js"
import style0 from "./AssetsCorpPage.vue?vue&type=style&index=0&id=8cc90de6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc90de6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8cc90de6')) {
      api.createRecord('8cc90de6', component.options)
    } else {
      api.reload('8cc90de6', component.options)
    }
    module.hot.accept("./AssetsCorpPage.vue?vue&type=template&id=8cc90de6&scoped=true", function () {
      api.rerender('8cc90de6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/use-metrics/pages/AssetsCorpPage.vue"
export default component.exports